import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { IndicadoresService } from '../../services/indicadores.service';

@Component({
   selector: 'app-indicadores',
   imports: [CommonModule],
   standalone: true,
   templateUrl: './indicadores.component.html',
   styleUrls: ['./indicadores.component.scss']
})
export class IndicadoresComponent {
   indicadores: {
      cdi: number,
      ipca: number,
      selic: number,
   }
   dolarCompra: number = 0;
   dolarVenda: number = 0;
   constructor(
      private indicadoresService: IndicadoresService
   ) {
      this.getDolar();
      this.getTaxas();
   }

   getDolar() {
      const date = new Date();
      //dia -1
      date.setDate(date.getDate() - 1);
      // Formata a data para o formato 'YYYY-MM-DD'
      const formattedDate = date.toISOString().split('T')[0];
      this.indicadoresService.cambioGet('USD', formattedDate).then((data: any) => {
         this.dolarCompra = data.cotacoes[data.cotacoes.length - 1].cotacao_compra;
         this.dolarVenda = data.cotacoes[data.cotacoes.length - 1].cotacao_venda;
      }
      ).catch((error: any) => {
         console.error('Erro ao buscar indicadores:', error);
      }
      );

   }
   getTaxas() {
      this.indicadoresService.getAllTaxas().then((data) => {
         this.indicadores = {
            cdi: data.find((item: any) => item.nome === 'CDI')?.valor || 0,
            ipca: data.find((item: any) => item.nome === 'IPCA')?.valor || 0,
            selic: data.find((item: any) => item.nome === 'Selic')?.valor || 0,
         }
      }
      ).catch((error: any) => {
         console.error('Erro ao buscar taxas:', error);
      }
      );
   }
}
